import FilterForm from '../../../components/forms/FilterForm';
import {
  CreateButton,
  DateField,
  ShowButton,
  TextField,
  useTable
} from '@refinedev/antd';
import { CrudFilters, HttpError } from '@refinedev/core';
import { Form, Input, Space, Table } from 'antd';
import { IProductBonus } from 'interfaces/product_bonuses';
import { ListLayout } from '../../../components/layout/layout/ListLayout';

interface IFilter {
  byUserName: string;
  byProductName: string;
}

export const BonusList = () => {
  const { tableProps, searchFormProps } = useTable<
    IProductBonus,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const filters: CrudFilters = [];
      const { byUserName, byProductName } = params;

      filters.push(
        {
          field: 'filter[by_user_name]',
          operator: 'eq',
          value: byUserName
        },
        {
          field: 'filter[by_product_name]',
          operator: 'eq',
          value: byProductName
        }
      );

      return filters;
    }
  });

  return (
    <ListLayout title="Bônus">
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="byUserName">
          <Input placeholder="Nome do usuário" className="lg:min-w-[300px]" />
        </Form.Item>
        <Form.Item name="byProductName">
          <Input placeholder="Nome do produto" className="lg:min-w-[300px]" />
        </Form.Item>
      </FilterForm>
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="id"
          key="id"
          title="ID"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="user"
          key="user"
          title="Usuário"
          render={value => <TextField value={value.full_name_or_name} />}
        />
        <Table.Column
          dataIndex="product"
          key="product"
          title="Produto"
          render={value => <TextField value={value.name} />}
        />
        <Table.Column
          dataIndex="expires_at"
          key="expires_at"
          title="Expiração"
          render={value => <DateField value={value} />}
        />
        <Table.Column<IProductBonus>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={80}
          render={(_, record) => {
            return (
              <Space>
                <ShowButton hideText size="small" recordItemId={record.id} />
              </Space>
            );
          }}
        />
      </Table>
      <CreateButton resource="bulk_product_bonuses">Lote</CreateButton>
    </ListLayout>
  );
};
